<template>
    <div class="gm-style-mtc">
        <button @click="onClick">
            <IconComp
                icon="fa-square-check"
                v-if="state"
            />
            <IconComp
                icon="fa-square"
                v-else
            />
            {{ $tm(title) }}
        </button>
    </div>
</template>
<script lang="ts" setup>
import { $tm } from '@/locize';
import { IconComp } from '@/components';
import { computed, ref, watch } from 'vue';

const props = defineProps<{
    modelValue?: boolean;

    title: string;

    type: 'checkbox';
}>();

// the state of the checkbox
const state = ref<boolean>(props.modelValue);

const value = computed<boolean>({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val),
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void;
    (e: 'click', value: boolean): void;
}>();

/**
 * Handle the modelValue changes
 */
const onClick = () => {
    state.value = !state.value;
    value.value = state.value;
    emit('click', state.value);
};
</script>
